import { AUTH_SSO } from "../modules/constants";

export async function authSSO(data) {
  const url = AUTH_SSO;

  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      // "app-version": "7.4.0",
      // "app-platform": "pwa",
    },
    body: JSON.stringify(data),
  };
  try {
    const response = await fetch(url, config);

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const responseData = await response.json();

    return {
      data: responseData,
      status: response.status,
      statusText: response.statusText,
      headers: Object.fromEntries(response.headers.entries()),
      config,
      request: response,
    };
  } catch (error) {
    throw new Error(`SSO Auth failed: ${error.message}`);
  }
}
